import jwtDecode from 'jwt-decode'
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from '../../utils/localStorage'
import { ACCESS_TOKEN, REFRESH_TOKEN, SCOPE_MODE } from '../../utils/constants'
import { ACCOUNT_INITIALISE, LOGIN } from '../../store/actions'
import { onError, onErrorTxt } from '../../utils/CommonMethods'
import { BoUrl } from '../../services/BO-path-url'
import { url } from '../../services/path-url'
import { getDataService } from '../../services/back-end-service'

export const saveTokenProfile = (responseData, i18n) => {
  const decoded = jwtDecode(responseData.accesstoken)
  setLocalStorage(REFRESH_TOKEN, responseData.refreshtoken)
  setLocalStorage('profile', JSON.stringify(responseData?.picture))
  setLocalStorage('timezone', responseData?.time_zone)
  setLocalStorage('logo', responseData.logo)

  setLocalStorage('LANGUAGE', decoded?.language)
  i18n.changeLanguage(decoded?.language)

  setLocalStorage('username', decoded?.name)
  setLocalStorage('user_id', decoded?.iduser)
  setLocalStorage('appname', decoded?.iss)
  setLocalStorage('customername', decoded?.customer)
  setLocalStorage('entity_scope', decoded?.entity_scope_name)
  setLocalStorage('entity_id', decoded?.idfiliale)
  setLocalStorage(SCOPE_MODE, 0)

  return decoded
}

export const saveMenuData = (menu, isBo = false) => {
  setLocalStorage('menu', JSON.stringify(menu.items))
  if (menu.video) setLocalStorage('video_help', JSON.stringify(menu.video))
  setLocalStorage('AdminMenu', JSON.stringify(menu.admin))
  setLocalStorage('entity', JSON.stringify(menu.entity))
  setLocalStorage('scope', JSON.stringify(menu.scope))
  setLocalStorage('entity_scope_table', JSON.stringify(menu.entity_scope))

  setLocalStorage(
    'clientAccess',
    isBo ? JSON.stringify(menu.client_access) : {}
  )

  if (menu.column_settings) {
    setLocalStorage('preference', JSON.stringify(menu.column_settings || '[]'))
    removeLocalStorage('configColumn')
  }

  if (menu.block_column_settings) {
    setLocalStorage(
      'blockColumnSettings',
      JSON.stringify(menu.block_column_settings || '[]')
    )
  }
}

export const createAuthHandlers = ({ dispatch, history, i18n, websocket }) => {
  const onFailure = (err) => {
    dispatch({
      type: ACCOUNT_INITIALISE,
      payload: { isLoggedIn: false, user: null },
    })
    onError(err)
  }

  const onSuccessMenu = async (data, isBoMode = false) => {
    saveMenuData(data, isBoMode)

    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        isInitialised: true,
        isExpiredPassword: data?.isExpiredPassword,
        menu: data.items,
        admin: data.admin,
        entity: data.entity,
        scope: data.scope,
        client_access: data?.client_access || {},
      },
    })

    if (isBoMode) {
      history.replace('/bo/dashboard')
      return
    }

    const redirectUrl = '/dashboard'
    history.replace(redirectUrl, { active_page: 2 })
    websocket().send(
      `{"type":"authentification","token":"${getLocalStorage(ACCESS_TOKEN)}"}`
    )
  }

  const onSuccessAuth = (response, isBoMode = false) => {
    const isExpiredPwd = response?.data?.expired_password

    isBoMode
      ? setLocalStorage('ACCESS_TOKEN_BO', response.data.accesstoken)
      : setLocalStorage(ACCESS_TOKEN, response.data.accesstoken)

    if (response?.data?.totp === true) {
      dispatch({
        type: LOGIN,
        payload: { isLoggedIn: false, isInitialised: false, isOtp: true },
      })
      return
    }

    saveTokenProfile(response.data, i18n)
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        isInitialised: true,
        isExpiredPassword: isExpiredPwd,
        menu: [],
        admin: [],
        entity: [],
        scope: [],
        client_access: {},
      },
    })

    if (isExpiredPwd) {
      history.replace('/user/auth/update-password', { active_page: 2 })
      return
    }
    const menuUrl = isBoMode ? BoUrl.menu : url.user.menu
    getDataService(
      menuUrl,
      (data) =>
        onSuccessMenu({ ...data, isExpiredPassword: isExpiredPwd }, isBoMode),
      onFailure
    )
  }

  const onErrorAuth = (err) => {
    onError(err)
    setTimeout(() => {}, 1500)
  }

  const onErrorAuthOtp = (token) => {
    onErrorTxt('Invalid code')
    dispatch({
      type: LOGIN,
      payload: { isLoggedIn: false, isInitialised: false, isOtp: true },
    })
    setLocalStorage(ACCESS_TOKEN, token)
  }

  return {
    onFailure,
    onSuccessMenu,
    onSuccessAuth,
    onErrorAuth,
    onErrorAuthOtp,
  }
}

